/* eslint-disable camelcase */
import { IEventPoiagg, IPoi } from "~/interfaces";
import { getDetail } from "~/util/providers/review";
import { IReviewData } from "~/mymaps2/reviews/interfaces";
import { IReviewItem, IReview } from "~/review/interfaces";

interface IReviewCacheItem {
	poi: IEventPoiagg;
	review: IReviewData;
}

// pole vsech review uzivatele, ktera pridal ci upravil v tehle session
let newReviews: Array<IReviewCacheItem> = [];

// pole id vsech review uzivatele, ktera v tehle session smazal
let deletedReviews: Array<number> = [];

/**
 * Přidá recenzi do cache i s informacemi o POI k němu
 * @param poi data z detailu/description
 * @param review data z firem k hodnoceni
 */
export function putToCache(poi: IEventPoiagg, review: IReviewData) {
	const reviewId = review.id;
	const indexNew = newReviews.findIndex(newReview => newReview.review.id === reviewId);

	// pokud to v cache neni, vlozime to tam
	if (indexNew === -1) {
		newReviews.push({
			poi,
			review,
		});
	// najdeme to v cache a updatujeme
	} else {
		newReviews.splice(indexNew, 1, {
			poi,
			review,
		});
	}

	// pokud je id ve smazanych -> odstranime jej
	const indexDeleted = deletedReviews.findIndex(id => id === reviewId);

	if (indexDeleted !== -1) {
		deletedReviews.splice(indexDeleted, 1);
	}
}

export function putToCacheWithoutDetail(putReviewData: { review: IReview; myReview: IReviewItem }, source: string, id: number | string) {
	getDetail({ source, id, fetchPhotos: true }).then(detailData => {
		const poi = detailData.poi;

		if (poi.review) {
			Object.assign(poi.review, putReviewData.review);
		}

		if (poi.gallery && poi.gallery.length && poi.gallery[0].media && poi.gallery[0].media.length) {
			poi.media = {
				mimetype: "",
				urls: poi.gallery[0].media[0].urls,
			};
		} else {
			poi.media = {};
		}

		putToCache(poi, putReviewData.myReview);
	}, () => { /**/ });
}

export function hasDeletedReviewById(reviewId: number) {
	const indexDeleted = deletedReviews.findIndex(id => id === reviewId);

	return indexDeleted !== -1;
}

export function updateMyReviewFromDeletedCache(detailData: IPoi) {
	if (detailData.myReview) {
		// vynulujeme data
		if (hasDeletedReviewById(detailData.myReview.id)) {
			detailData.myReview = null;
		}
	}
}

/**
 * Smaže recenzi z cache podle jejiho id
 */
export function deleteFromCache(reviewId: number) {
	// odebrat z novych, pokud tam uz je
	const indexNew = newReviews.findIndex(review => review.review.id === reviewId);

	if (indexNew !== -1) {
		newReviews.splice(indexNew, 1);
	}

	// pridat do smazanych, pokud tam jeste neni
	if (!hasDeletedReviewById(reviewId)) {
		deletedReviews.push(reviewId);
	}
}

/**
 * Vrátí review z cache podle zadaného POIe
 * @param source source POIe
 * @param id id POIe
 */
export function readFromCache(source: string, id: number) {
	const indexNew = newReviews.findIndex(review => review.poi.source === source && review.poi.id === id);

	return indexNew === -1 ? null : JSON.parse(JSON.stringify(newReviews[indexNew]));
}

export function readAllCache() {
	return JSON.parse(JSON.stringify(newReviews));
}

// update pole mych hodnoceni, bez ohledu na to, k jakemu jsou POIi
export function updateListFromCache(reviews: Array<IReviewData>, ignoreNew = false) {
	// smazeme to, co uz tam byt nema, tedy smazane a nove pridane, ktere mame prikaz ignorovat
	let pruned = reviews.filter(review => {
		const notDeleted = deletedReviews.indexOf(review.id) === -1;
		const notNew = newReviews.findIndex(newReview => newReview.review.id === review.id) === -1;

		return notDeleted && notNew;
	});

	// primichame nove na zacatek
	if (!ignoreNew) {
		pruned = [...newReviews.map(review => ({
			...review.review ? review.review : {},
			premise: {
				source: review.poi.source,
				id: review.poi.id,
			},
			description: {
				...review.poi,
			},
			detail_poi: {
				source: review.poi.source,
				id: review.poi.id,
			},
			review_poi: {
				source: review.poi.source,
				id: review.review.premise?.id || review.poi.firmId || review.poi.id,
			},
		})), ...pruned];
	}

	// nove pole vratime zpatky
	return pruned;
}

export function emptyCache() {
	newReviews = [];
	deletedReviews = [];
}
